"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditCycleCountReview = void 0;
const core_1 = require("@material-ui/core");
const button_1 = require("client/components/material/button");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const text_area_1 = require("client/components/material/text-area");
const ui_1 = require("client/components/ui");
const callable_1 = require("client/components/ui/callable");
const store_1 = require("client/modules/inventory/modules/inventory-list/store");
const store_2 = require("client/modules/sites/modules/sites-detail/store");
const store_3 = require("client/modules/stocks/store");
const Warning_1 = require("material-ui-icons/Warning");
const Collapse_1 = require("material-ui/transitions/Collapse");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const ramda_1 = require("ramda");
const React = require("react");
const react_1 = require("react");
const ReactTooltip = require("react-tooltip");
const inventory_site_lot_1 = require("shared/inventory-site-lot");
const uppercase_string_1 = require("shared/util/uppercase-string");
const throttle_debounce_1 = require("throttle-debounce");
const lot_update_table_1 = require("./components/lot-update-table");
require("./edit-cycle-count-review.less");
const columns = [
    {
        label: "ndc",
        id: "package"
    },
    {
        label: "name",
        id: "name"
    },
    {
        label: "pkg qty/form",
        id: "dosage"
    },
    {
        label: "hand count",
        id: "count"
    },
    {
        label: "actual qty",
        id: "qty"
    }
];
let EditCycleCountReview = class EditCycleCountReview extends react_1.Component {
    constructor() {
        super(...arguments);
        this.showChildren = {};
        this.isCollapse = true;
        this.checkedRowId = -1;
        this.editInventoryId = -1;
        this.currentRowIndex = -1;
        this.order = "ASC";
        this.orderBy = "package";
        this.filterText = "";
        this.autoFocusForm = true;
        this.activeSite = store_2.sitesDetailStore.site.value;
        this.siteInventoryCycleCountAndActualQuantity = new Map();
        this.countUpdateMetas = new Map();
        this.inventoriesLots = new Map();
        this.inventoriesLotsOriginal = new Map();
        this.inventoriesResolved = new Map();
        this.loadInventory = throttle_debounce_1.debounce(200, async () => {
            const options = {
                count: 100,
                order: this.order,
                search: this.filterText,
                start: 0,
                where: `inventorysite.siteId = ${this.activeSite.id} AND inventorysite.active = true`,
                sort: this.orderBy
            };
            await store_1.inventoryListStore.loadInventory(options);
        });
        this.loadInventorySiteLots = throttle_debounce_1.debounce(200, async () => {
            const options = {
                count: 100,
                order: "",
                search: "",
                start: 0,
                where: ``,
                sort: "",
                siteId: this.activeSite.id
            };
            await store_1.inventoryListStore.loadInventorySiteLots(options);
            this.initializeInventoryLots();
        });
        this.initializeInventoryLots = () => {
            this.inventoriesLots.clear();
            this.inventoriesLotsOriginal.clear();
            const { inventorySiteLots: { value: lots = [] } } = store_1.inventoryListStore;
            for (const lot of lots) {
                const inventoryId = lot.inventorySite.inventoryId;
                if (this.inventoriesLots.has(inventoryId)) {
                    const inventoriesLots = Object.assign({}, this.inventoriesLots.get(inventoryId));
                    const inventoriesLotsOriginal = Object.assign({}, this.inventoriesLotsOriginal.get(inventoryId));
                    inventoriesLots[lot.id] = lot;
                    inventoriesLotsOriginal[lot.id] = Object.assign({}, lot);
                    this.inventoriesLots.set(inventoryId, inventoriesLots);
                    this.inventoriesLotsOriginal.set(inventoryId, ramda_1.clone(inventoriesLotsOriginal));
                }
                else {
                    const inventoriesLots = {};
                    const inventoriesLotsOriginal = {};
                    inventoriesLots[lot.id] = lot;
                    inventoriesLotsOriginal[lot.id] = Object.assign({}, lot);
                    this.inventoriesLots.set(inventoryId, inventoriesLots);
                    this.inventoriesLotsOriginal.set(inventoryId, ramda_1.clone(inventoriesLotsOriginal));
                }
            }
        };
        this.initializeCycleCountAndActualQuantity = () => {
            const { inventory: { value = [] } } = store_1.inventoryListStore;
            this.siteInventoryCycleCountAndActualQuantity.clear();
            this.countUpdateMetas.clear();
            // get the count from the previous page and also set the actual count.
            for (const group of value) {
                if (group && group.children && group.children.length) {
                    for (const child of group.children) {
                        const inventoryLots = this.inventoriesLots.get(child.id);
                        const lots = inventoryLots ? Object.values(inventoryLots) : [];
                        // initialize actual quantity.
                        const inventorySite = child.sites.find(site => site.siteId === this.activeSite.id);
                        if (inventorySite) {
                            const { quantity } = inventorySite;
                            const cycleCountAndActualQuantity = {
                                handCount: this.props.siteInventoryCycleCount
                                    ? this.props.siteInventoryCycleCount.get(child.id)
                                    : 0,
                                actualCount: quantity
                            };
                            this.siteInventoryCycleCountAndActualQuantity.set(child.id, cycleCountAndActualQuantity);
                            // initialize countUpdateMetas
                            const countUpdateMeta = {
                                exceptionReason: "",
                                action: cycleCountAndActualQuantity.handCount ===
                                    cycleCountAndActualQuantity.actualCount
                                    ? null
                                    : inventory_site_lot_1.UserAction.MatchHandCount
                            };
                            this.countUpdateMetas.set(child.id, countUpdateMeta);
                        }
                        else {
                            const cycleCountAndActualQuantity = {
                                handCount: this.props.siteInventoryCycleCount
                                    ? this.props.siteInventoryCycleCount.get(child.id)
                                    : 0,
                                actualCount: 0
                            };
                            this.siteInventoryCycleCountAndActualQuantity.set(child.id, cycleCountAndActualQuantity);
                            // initialize countUpdateMetas
                            const countUpdateMeta = {
                                exceptionReason: "",
                                action: null
                            };
                            this.countUpdateMetas.set(child.id, countUpdateMeta);
                        }
                        // END IF/ELSE
                    }
                }
            }
        };
        this.renderGroupedListRow = (row, index) => {
            const filteredChildren = row.children.filter((child) => {
                if (this.siteInventoryCycleCountAndActualQuantity.has(child.id)) {
                    const countCycleAndActual = this.siteInventoryCycleCountAndActualQuantity.get(child.id);
                    if (countCycleAndActual.actualCount !== countCycleAndActual.handCount) {
                        return true;
                    }
                    return false;
                }
                return false;
            });
            if (!filteredChildren || !filteredChildren.length) {
                return null;
            }
            return (React.createElement("div", { key: index },
                React.createElement(list_item_1.MaterialListItem, { category: list_item_1.IListItemCategory.GroupHeader, onClick: () => {
                        this.handleClickGroup(index);
                    } },
                    React.createElement(list_item_text_1.MaterialListItemText, { groupHeader: true, primary: `${row.group || CONFIG.emptyText}` })),
                React.createElement(Collapse_1.default, { in: this.showChildren[index] !== false },
                    React.createElement(list_1.MaterialList, { rows: filteredChildren, renderRow: this.renderGroupedListChild }))));
        };
        this.renderGroupedListChild = (child, index) => {
            const className = this.currentRowIndex === index
                ? "list-component__row edit-active"
                : "list-component__row edit-inactive";
            const resolveStatus = this.inventoriesResolved.get(child.id)
                ? "inventory-resolved"
                : "";
            const inventorysite = child.sites &&
                child.sites.find(inventorysite => inventorysite.inventoryId === child.id);
            const countUpdateMeta = this.countUpdateMetas.has(child.id)
                ? this.countUpdateMetas.get(child.id)
                : { exceptionReason: "", action: "" };
            const inventoryName = child.strengthDescription || child.name || child.generic;
            const dosage = child.dosage || "";
            return [
                React.createElement(list_item_1.MaterialListItem, { key: index, className: `${className} ${resolveStatus}`, onClick: () => this.handleClickChild(child, index) },
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: child.package }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: uppercase_string_1.uppercaseString(inventoryName) }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: uppercase_string_1.uppercaseString(dosage) }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: this.siteInventoryCycleCountAndActualQuantity.has(child.id)
                            ? this.siteInventoryCycleCountAndActualQuantity.get(child.id)
                                .handCount
                            : "" }),
                    React.createElement(list_item_text_1.MaterialListItemText, { primary: React.createElement("div", { className: "warning-quantity" },
                            this.siteInventoryCycleCountAndActualQuantity.has(child.id)
                                ? this.siteInventoryCycleCountAndActualQuantity.get(child.id)
                                    .actualCount
                                : "",
                            (!countUpdateMeta.exceptionReason ||
                                !countUpdateMeta.action) && (React.createElement(Warning_1.default, { className: "warning warning-quantity--icon", "data-tip": "Exception reason and action required.", "data-place": "right", "data-for": "warning-icon", fill: "#eeb20d" }))) })),
                this.renderChildRowEditMode(child, index)
            ];
        };
        this.renderForm = () => (React.createElement(ui_1.UiForm, { buttons: ["Finish"], submitClassName: "custom-btn-fit-content", loading: this.props.loading, isChanged: () => true, status: this.status, saved: "Submitted", onSubmit: this.handleCancel, error: this.props.error, shouldDisableSave: this.shouldDisableSubmit() },
            React.createElement("div", { className: "inventory__list" }, this.renderGroupedList())));
        this.renderSiteInventoryException = (inventory, index) => {
            const inventoryLots = this.inventoriesLots.has(inventory.id)
                ? this.inventoriesLots.get(inventory.id)
                : null;
            const inventoryLotsOriginal = this.inventoriesLotsOriginal.has(inventory.id)
                ? this.inventoriesLotsOriginal.get(inventory.id)
                : null;
            const resolvedStatus = this.inventoriesResolved.get(inventory.id)
                ? "inventory-resolved__lightest"
                : "";
            const countUpdateMeta = this.countUpdateMetas.has(inventory.id)
                ? this.countUpdateMetas.get(inventory.id)
                : { exceptionReason: "", action: "" };
            const isMatchLotQty = () => {
                if (!inventoryLots) {
                    return true;
                }
                const totalLotQty = Object.values(inventoryLots).reduce((acc, cur) => acc + Number(cur.quantity), 0);
                const handCount = this.siteInventoryCycleCountAndActualQuantity.get(inventory.id).handCount;
                return totalLotQty === handCount;
            };
            const needToMatchLotQty = countUpdateMeta.action === inventory_site_lot_1.UserAction.MatchHandCount;
            const hasAlreadyBeenResolved = this.inventoriesResolved.get(inventory.id);
            console.log("hasAlreadyBeenResolved", hasAlreadyBeenResolved);
            console.log("no exceptionReason", !countUpdateMeta.exceptionReason);
            console.log("no action", !countUpdateMeta.action);
            console.log("needToMatchLotQty", needToMatchLotQty);
            console.log("isMatchLotQty", isMatchLotQty());
            const shouldDisableResolve = hasAlreadyBeenResolved ||
                !countUpdateMeta.exceptionReason ||
                !countUpdateMeta.action ||
                (needToMatchLotQty && !isMatchLotQty());
            console.log("shouldDisableResolve", shouldDisableResolve);
            return (React.createElement("div", { className: "main-stock" },
                React.createElement("div", { className: "sub-main-stock" },
                    React.createElement("div", { className: "site-name" },
                        React.createElement("h3", null, inventory.generic),
                        React.createElement("h4", null,
                            inventory.strengthDescription || inventory.name,
                            " |",
                            " ",
                            inventory.package)),
                    React.createElement("div", { className: `${"inventorysite-info--exception"} ${resolvedStatus}` },
                        React.createElement("div", { className: "row--action" },
                            React.createElement(core_1.FormControl, { component: "fieldset" },
                                React.createElement(core_1.FormLabel, { component: "legend" }, "Exception Reason"),
                                React.createElement(text_area_1.MaterialTextArea, { placeholder: "*Please provide a reason...", required: true, value: this.countUpdateMetas.has(inventory.id)
                                        ? this.countUpdateMetas.get(inventory.id).exceptionReason
                                        : "", onChange: this.handleReasonChange(inventory) })),
                            React.createElement(core_1.FormControl, { component: "fieldset" },
                                React.createElement(core_1.FormLabel, { component: "legend" }, "Action"),
                                React.createElement(core_1.RadioGroup, { "aria-label": "Action", name: "action", value: this.countUpdateMetas.has(inventory.id)
                                        ? this.countUpdateMetas.get(inventory.id).action
                                        : inventory_site_lot_1.UserAction.MatchHandCount, onChange: this.handleActionChange(inventory), className: "form-radio-group" },
                                    React.createElement(core_1.FormControlLabel, { value: inventory_site_lot_1.UserAction.MatchHandCount, control: React.createElement(core_1.Radio, null), label: "Match cycle count quantity" }),
                                    React.createElement(core_1.FormControlLabel, { value: inventory_site_lot_1.UserAction.MatchActualCount, control: React.createElement(core_1.Radio, null), label: "Match system quantity" }))),
                            this.countUpdateMetas.has(inventory.id) &&
                                this.countUpdateMetas.get(inventory.id).action ===
                                    inventory_site_lot_1.UserAction.MatchHandCount && (React.createElement(lot_update_table_1.LotUpdateTable, { inventoryLots: inventoryLots, inventoryLotsOriginal: inventoryLotsOriginal })),
                            React.createElement("div", { className: "row--action__resolve" },
                                React.createElement(button_1.MaterialButton, { onClick: this.handleQuantityResolve(inventory, index), primary: true, disabled: shouldDisableResolve }, "Resolve")))))));
        };
        this.handleQuantityResolve = (inventory, index) => async (event) => {
            const { action = inventory_site_lot_1.UserAction.MatchActualCount, exceptionReason = "Not specified" } = this.countUpdateMetas.get(inventory.id) || {};
            if (!action) {
                alert("Please select an action");
                return;
            }
            if (!exceptionReason) {
                alert("Please specify a reason");
                return;
            }
            const inventoryLots = this.inventoriesLots.get(inventory.id);
            const lots = inventoryLots ? Object.values(inventoryLots) : [];
            const cycleCountAndActualQuantity = this.siteInventoryCycleCountAndActualQuantity.get(inventory.id);
            const cycleCountHeader = store_3.stocksStore.cycleCountSavedInitial;
            await store_3.stocksStore.updateInventoryQuantityAndLot(this.activeSite, action, exceptionReason, inventory, lots, cycleCountAndActualQuantity, cycleCountHeader);
            this.inventoriesResolved.set(inventory.id, true);
            this.handleClickChild(inventory, index);
        };
        this.handleReasonChange = (inventory) => (event, value) => {
            if (this.countUpdateMetas.has(inventory.id)) {
                const countUpdateMeta = Object.assign({}, this.countUpdateMetas.get(inventory.id));
                countUpdateMeta.exceptionReason = value;
                this.countUpdateMetas.set(inventory.id, countUpdateMeta);
            }
            else {
                const countUpdateMeta = {
                    exceptionReason: value,
                    action: inventory_site_lot_1.UserAction.MatchHandCount
                };
                this.countUpdateMetas.set(inventory.id, countUpdateMeta);
            }
            this.inventoriesResolved.set(inventory.id, false);
        };
        this.handleActionChange = (inventory) => (event, value) => {
            if (this.countUpdateMetas.has(inventory.id)) {
                const countUpdateMeta = Object.assign({}, this.countUpdateMetas.get(inventory.id));
                countUpdateMeta.action = value;
                this.countUpdateMetas.set(inventory.id, countUpdateMeta);
            }
            else {
                const countUpdateMeta = {
                    exceptionReason: "",
                    action: value
                };
                this.countUpdateMetas.set(inventory.id, countUpdateMeta);
            }
            this.inventoriesResolved.set(inventory.id, false);
        };
        this.renderChildRowEditMode = (child, index) => {
            const resolveStatus = this.inventoriesResolved.get(child.id)
                ? "inventory-resolved__lighter"
                : "";
            return (React.createElement("div", { className: "lot-exception-container", key: -1 }, this.editInventoryId === child.id && !this.isCollapse && (React.createElement("div", { className: "edit-inventorysite", key: -1 },
                React.createElement("div", { className: `${"list-component__row list-component__row--exception"} ${resolveStatus}` }, this.renderSiteInventoryException(child, index))))));
        };
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            this.loadInventory();
        };
        this.isChanged = (inventory) => {
            const site = store_2.sitesDetailStore.site.value;
            if (!site) {
                return false;
            }
            this.status = ui_1.FormStatus.Clean;
            return false;
        };
        this.handleCancel = () => {
            this.props.onCancel();
        };
        this.handleClickGroup = (index) => {
            this.showChildren = ramda_1.merge(this.showChildren, {
                [index]: this.showChildren[index] === false ? true : false
            });
        };
        this.handleClickChild = (child, index) => {
            if (this.editInventoryId === child.id) {
                this.isCollapse = !this.isCollapse;
            }
            else {
                this.isCollapse = false;
            }
            if (this.isChanged(child)) {
                this.status = ui_1.FormStatus.Dirty;
            }
            else {
                this.status = ui_1.FormStatus.Clean;
            }
            this.checkedRowId = -1;
            this.editInventoryId = child.id;
            this.currentRowIndex = index;
        };
        this.onCallback = (value) => {
            this.autoFocusForm = false;
            this.filterText = value;
            this.loadInventory();
        };
        this.shouldDisableSubmit = () => {
            const filterMismatchOnly = (entry) => {
                const cycleCount = this.siteInventoryCycleCountAndActualQuantity.get(Number(entry[0]));
                return cycleCount
                    ? !(cycleCount.actualCount === cycleCount.handCount)
                    : false;
            };
            return (Array.from(this.countUpdateMetas.entries())
                .filter(filterMismatchOnly)
                .some(entry => !entry[1].exceptionReason || !entry[1].action) ||
                Array.from(this.inventoriesResolved.values()).some((resolved) => !resolved));
        };
        this.handleSubmit = () => {
            const cycleCountInventories = [];
            for (const [key, value] of this.siteInventoryCycleCountAndActualQuantity) {
                const countMeta = this.countUpdateMetas.get(key);
                const cycleCountInventory = Object.assign({ inventoryId: key, qtyDifference: Math.abs(value.actualCount - value.handCount), blindCountQty: value.handCount, actualCountQty: value.actualCount }, countMeta);
                cycleCountInventories.push(cycleCountInventory);
            }
            callable_1.callable(this.props.onSave)(this.activeSite, cycleCountInventories);
        };
    }
    componentWillMount() {
        if (this.activeSite) {
            this.loadInventory();
        }
    }
    async componentDidMount() {
        await this.loadInventorySiteLots();
        this.initializeInventoryLots();
        this.initializeCycleCountAndActualQuantity();
    }
    componentWillReceiveProps(props) {
        this.activeSite = store_2.sitesDetailStore.site.value;
        this.loadInventory();
        this.loadInventorySiteLots();
        this.initializeInventoryLots();
        this.initializeCycleCountAndActualQuantity();
        this.status = this.props.status || ui_1.FormStatus.Clean;
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    renderGroupedList() {
        const { inventory: { value = [] } } = store_1.inventoryListStore;
        return (React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: value, renderRow: this.renderGroupedListRow, resizableheader: true, customClass: "custom-material-list__cycle-count-list--review" }));
    }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement(ReactTooltip, { id: "warning-icon", className: "tooltip", effect: "solid", place: "left", "data-type": "warning", multiline: true }),
            React.createElement("div", { className: "site-edit-inventory" }, this.renderForm())));
    }
};
__decorate([
    mobx_1.observable
], EditCycleCountReview.prototype, "showChildren", void 0);
__decorate([
    mobx_1.observable
], EditCycleCountReview.prototype, "isCollapse", void 0);
__decorate([
    mobx_1.observable
], EditCycleCountReview.prototype, "status", void 0);
__decorate([
    mobx_1.observable
], EditCycleCountReview.prototype, "checkedRowId", void 0);
__decorate([
    mobx_1.observable
], EditCycleCountReview.prototype, "editInventoryId", void 0);
__decorate([
    mobx_1.observable
], EditCycleCountReview.prototype, "currentRowIndex", void 0);
__decorate([
    mobx_1.observable
], EditCycleCountReview.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], EditCycleCountReview.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], EditCycleCountReview.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], EditCycleCountReview.prototype, "autoFocusForm", void 0);
__decorate([
    mobx_1.observable
], EditCycleCountReview.prototype, "activeSite", void 0);
__decorate([
    mobx_1.observable
], EditCycleCountReview.prototype, "siteInventoryCycleCountAndActualQuantity", void 0);
__decorate([
    mobx_1.observable
], EditCycleCountReview.prototype, "countUpdateMetas", void 0);
__decorate([
    mobx_1.observable
], EditCycleCountReview.prototype, "inventoriesLots", void 0);
__decorate([
    mobx_1.observable
], EditCycleCountReview.prototype, "inventoriesLotsOriginal", void 0);
__decorate([
    mobx_1.observable
], EditCycleCountReview.prototype, "inventoriesResolved", void 0);
EditCycleCountReview = __decorate([
    mobx_react_1.observer
], EditCycleCountReview);
exports.EditCycleCountReview = EditCycleCountReview;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/stocks/modules/sites-detail/components/edit-cycle-count/components/edit-cycle-count-review/edit-cycle-count-review.tsx
// module id = 4102
// module chunks = 0